import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-stepper', {
    month: {
        1: 'kuu',
        2: 'kuud',
    },
    year: {
        1: 'aasta',
        2: 'aastat',
    },
    increase: 'Suurenda',
    decrease: 'Vähenda',
    value: 'Väärtus',
    max: 'Maksimaalne',
    min: 'Minimaalne',
});
